import TimeModal from "@/Components/Order/TimeModal";
import useLiveShowedOrders from "@/shared/atoms/useLiveShowedOrders";
import useLiveDayOrders from "@/shared/hooks/useLiveDayOrders";
import useUserSettingsQuery from "@/shared/queries/user/useUserSettingsQuery";
import { OrderStatus } from "@/shared/utils/enum";
import { OrdersLive } from "@/shared/v2/queries/interfacesV2";
import { useEffect, useMemo, useState } from "react";

const LiveNewOrderModal = ({ data }: { data: OrdersLive }) => {
  const [show, setShow] = useState(false);
  const [showedNewOrder, setShowedNewOrder] = useLiveShowedOrders();
  const { data: settings } = useUserSettingsQuery();
  const dayOrders = useLiveDayOrders(data);
  const newOrder = useMemo(() => {
    return dayOrders
      ?.filter(
        (order) =>
          order?.order_information?.order_status === OrderStatus.ARRIVED &&
          !showedNewOrder.includes(order?.order_information?.item_id)
      )
      ?.filter((order) =>
        order?.order_information?.is_custom_time_slot_selected
          ? false
          : !settings.is_order_accepted_automatically &&
            !settings.is_pos_order_accepted_automatically
          ? true
          : settings.is_order_accepted_automatically &&
            !settings.is_pos_order_accepted_automatically
          ? order?.order_information?.source === 19
          : !settings.is_order_accepted_automatically &&
            settings.is_pos_order_accepted_automatically
          ? order?.order_information?.source !== 19
          : false
      );
  }, [dayOrders, settings, showedNewOrder]);

  useEffect(() => {
    if (newOrder.length !== 0) {
      setShow(true);
    }
  }, [newOrder]);

  return newOrder.length && show ? (
    <TimeModal
      onExit={() => {
        setShow(false);
        const [order, ...restOrders] = newOrder;
        setShowedNewOrder((prev) => [...prev, order.order_information.item_id]);
      }}
      onApproveFinish={() => {
        setShow(false);
        const [order, ...restOrders] = newOrder;
        setShowedNewOrder((prev) => [...prev, order.order_information.item_id]);
      }}
      order={newOrder[0]}
      isOrderConfirmAsapMinButtonActive={
        settings.order_confirm_asap_minutes_buttons_is_active
      }
      show={true}
    />
  ) : null;
};

export default LiveNewOrderModal;
